export default "__VITE_ASSET__0fa20b1e__"